import { render, staticRenderFns } from "./ShoppingListButton.vue?vue&type=template&id=4b92989e&scoped=true&"
import script from "./ShoppingListButton.vue?vue&type=script&lang=js&"
export * from "./ShoppingListButton.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListButton.vue?vue&type=style&index=0&id=4b92989e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b92989e",
  null
  
)

export default component.exports